module.exports = __webpack_public_path__ + "media/flags/pe-5051d6bf.svg";